<!--
 * @Author: M.D.
 * @Date: 2019-12-27 10:45:53
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="js-empty-list-ow">
    <div class="js-el-i-w">
      <img src="@/assets/image/empty_list_info.png" alt="">
      <div class="epty-info-txt">没有查询到相关信息，如有需要请拨打服务电话{{ servicePhone }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {

  },
  components: {

  }
}
</script>

<style lang="stylus">
.js-empty-list-ow
  min-height 300px
  background-color white
  center()
  .js-el-i-w
    text-align center
    .epty-info-txt
      text-align center
      font-size 18px
      color #aaaaaa
</style>
